import {CountUp} from 'countup.js';

document.querySelectorAll( '.facts .title' ).forEach( (el) => {
  let value = el.textContent ? el.textContent.replace( /,/g, '.' ) : '0';
  value = value.trim();

  let decimalPlaces = 0;
  if (!isNaN( value ) && value.includes( '.' )) {
    decimalPlaces = value.split( '.' )[1].length;
  }

  let countUp = new CountUp( el, value, {
    enableScrollSpy: true,
    scrollSpyOnce: true,
    decimalPlaces: decimalPlaces,
    separator: '.',
    decimal: ',',
  } );

  if (!countUp.error) {
    countUp.start();
  } else {
    console.error( countUp.error );
  }
} );